module.exports = __webpack_public_path__ + "img/estado-error.f00d3eec.svg";